import { render, staticRenderFns } from "./Region.vue?vue&type=template&id=72c5c3ea&scoped=true&"
import script from "./Region.vue?vue&type=script&lang=js&"
export * from "./Region.vue?vue&type=script&lang=js&"
import style0 from "./Region.vue?vue&type=style&index=0&id=72c5c3ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c5c3ea",
  null
  
)

export default component.exports